import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class LanguageDropdown extends React.Component {

  static propTypes = {
    onSelect: PropTypes.func,
    defaultText: PropTypes.string,
    options: PropTypes.array,
    selected: PropTypes.string,
    reservation: PropTypes.string,
    clearable: PropTypes.bool,
    searchable: PropTypes.bool,
    currentLanguageCode: PropTypes.string,
  }
  static defaultProps = {
    options: [],
    searchable: false,
    clearable: false,
  }

  onSelect = (languageCode) => {
    const { reservation } = this.props;
    window.location = `/reservations/${reservation}/${languageCode}`;
  }

  render() {
    const { options, selected, defaultText, clearable, searchable } = this.props;
    return (
      <Select
        onBlurResetsInput={false}
        onSelectResetsInput={false}
        options={options}
        simpleValue
        placeholder={defaultText}
        value={selected}
        onChange={this.onSelect}
        clearable={clearable}
        searchable={searchable}
      />
    );
  }
}

export default LanguageDropdown;



// WEBPACK FOOTER //
// ./src/components/organisms/LanguageDropdown/index.js